export default function getAdRefId(ad: any) {
  let prefix = ad.source?.includes('auk') ? 'A' : 'D';
  prefix =
    ad.source?.includes('landb') || ad.source?.includes('lantb') ? 'L' : prefix;
  const country =
    ad.source?.slice(-2).charAt(0).toUpperCase() + ad.source?.slice(-1);
  return `${prefix}-${country}-${ad.source_id}`;
}
